import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { HeaderStyle } from "../Common/styles/header";
import {
  a11yProps,
  CustomTabPanel2,
  StyledTab,
  StyledTabs,
} from "../Common/UI/TabPanel";
import { useSearchParams } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { useAppSelector } from "../../Redux/hooks";
import { permissions } from "../../utils/roles";
import EConsentList from "./EConsentList";

const ConsentTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [type, setType] = useState<string>(
    searchParams.get("type") || "consent"
  );
  const [searchText, setSearchText] = useState(
    searchParams.get("search") || ""
  );
  const [searchId, setSearchId] = useState(uuid());
  const [page, setPage] = useState(parseInt(searchParams.get("page") || "0"));

  const dataEditable = useAppSelector((state) => state.study.dataEditable);
  const studyPermissions = useAppSelector(
    (state) => state.study.studyPermissions
  );
  const [canEdit] = useState(
    dataEditable && studyPermissions.includes(permissions.studyDesigner)
  );

  useEffect(() => {
    const params = new URLSearchParams();
    params.set("type", type);
    params.set("page", page.toString());

    if (searchText) {
      params.set("search", searchText);
    }

    setSearchParams(params, {
      replace: true,
    });
  }, [setSearchParams, page, searchText, type]);

  const handleChange = (_: any, newValue: string) => {
    setType(newValue);
    setPage(0);
    setSearchId(uuid());
    setSearchText("");
  };

  return (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          Consent
        </Typography>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
        <StyledTabs value={type} onChange={handleChange}>
          <StyledTab label="Consent" value="consent" {...a11yProps(0)} />
          <StyledTab
            label="Sunshine Forms"
            value="sunshine"
            {...a11yProps(1)}
          />
        </StyledTabs>
      </Box>
      <Box
        sx={{
          p: 2.5,
          height: "calc(100% - 122px)",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CustomTabPanel2 value={type} index={type}>
          <EConsentList
            formType={type as "consent" | "sunshine"}
            page={page}
            setPage={setPage}
            searchText={searchText}
            setSearchText={setSearchText}
            searchId={searchId}
            setSearchId={setSearchId}
            canEdit={canEdit}
            type="study"
          />
        </CustomTabPanel2>
      </Box>
    </>
  );
};

export default ConsentTabs;
